import { useState, useEffect } from "react";

export const hasValidUserResponse = (quest, questData, selectedOptions, SelectedAnswers, textAnswers, userOrder) => {
  if (quest?.SubCategory === "Multiple Choice, Single Answer" || quest?.SubCategory === "Multiple Choice, Multiple Answers") {
    return selectedOptions?.length > 0;
  } else if (quest?.SubCategory === "Reading: Fill in the Blanks") {
    return questData && 
           SelectedAnswers?.length === questData?.AnswerNames?.length && 
           SelectedAnswers?.every(answer => answer !== null && answer !== undefined && answer !== "");
  } else if (quest?.SubCategory === "Reading & Writing: Fill in the Blanks") {
    return questData && 
           textAnswers?.length === questData?.AnswerNames?.length && 
           textAnswers?.every(answer => answer !== null && answer !== undefined && answer !== "");
  } else if (quest?.SubCategory === "Re-order Paragraphs") {
    return questData && questData?.OptionNames?.length > 0;
  }
  return false;
};

export const useReadingValidation = (quest, questData, selectedOptions, SelectedAnswers, textAnswers, userOrder) => {
  const [isNextButtonDisabled, setIsNextButtonDisabled] = useState(false);

  useEffect(() => {
    const hasValidResponse = hasValidUserResponse(quest, questData, selectedOptions, SelectedAnswers, textAnswers, userOrder);
    const shouldDisableNextButton = !hasValidResponse;

    // console.log(shouldDisableNextButton ? "Next Btn Disabled" : "Next Btn Enabled");

    setIsNextButtonDisabled(shouldDisableNextButton);
  }, [
    selectedOptions,
    SelectedAnswers,
    textAnswers,
    userOrder,
    quest,
    questData,
  ]);

  return { disabled: isNextButtonDisabled };
};
